export const VERIFY_ACCOUNT_TYPE = {
  MOBILE: 'MOBILE',
  EMAIL: 'EMAIL',
};

export const VERIFY_CODE_LENGTH = {
  MOBILE: 6,
  EMAIL: 6,
};

export const DEFAULT_BOOKING_TYPE_POB = 'pob';
